module.exports = __webpack_public_path__ + "static/media/kasnet.a0496424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/kasnet.png
// module id = 1989
// module chunks = 0